<template>
  <div class="rating-select border-1px">
    <div class="select-type border-1px">
      <span class="btn all" :class="{active:selectType === 2}" @click.stop="select(2,$event)">{{desc.all}}<span
        class="count">{{ratings.length}}</span></span>
      <span class="btn positive" :class="{active:selectType === 0}"
            @click.stop="select(0,$event)">{{desc.positive}}<span class="count">{{positives.length}}</span></span>
      <span class="btn negative" :class="{active:selectType === 1}"
            @click.stop="select(1,$event)">{{desc.negative}}<span class="count">{{negatives.length}}</span></span>
    </div>
    <div class="only-content" @click.stop="toggle($event)">
      <span class="icon-check_circle" :class="{active:onlyContent}"></span>
      <span class="text">只看有内容的评价</span>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  /* eslint-disable no-unused-vars */
  const POSITIVE = 0;
  /* eslint-disable no-unused-vars */
  const NEGATIVE = 1;
  const ALL = 2;
  export default{
    props: {
      ratings: {
        type: Array,
        default() {
          return [];
        }
      },
      desc: {
        type: Object,
        default() {
          return {
            all: '全部',
            positive: '满意',
            negative: '不满意'
          };
        }
      },
      selectType: {
        type: Number,
        default: ALL
      },
      onlyContent: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      positives() {
        return this.ratings.filter((rating) => {
          return rating.rateType === POSITIVE;
        });
      },
      negatives() {
        return this.ratings.filter((item) => {
          return item.rateType === NEGATIVE;
        });
      }
    },
    methods: {
      select(type, event) {
        if (!event._constructed) {
          return;
        }
        this.$emit('select', type);
      },
      toggle(event) {
        if (!event._constructed) {
          return;
        }
        this.$emit('toggle');
      }
    }
  };
</script>

<style rel="stylesheet/stylus" lang="stylus">
  @import "../../common/stylus/mixin.styl";
  .rating-select
    padding:0 18px
    border-1px(rgba(7, 17, 27, 0.1))
    .select-type
      padding-bottom:18px
      border-1px(rgba(7, 17, 27, 0.1))
      .btn
        margin-right:8px
        padding:8px 12px
        font-size:12px
        line-height:16px
        color:rgb(77, 85, 93)
        border-radius:2px
        &:last-child
          margin-right:0px
        .count
          font-size:8px
          margin-left:4px
      .all, .positive
        background-color:rgba(0, 160, 220, 0.2)
        &.active
          color:#fff
          background-color:rgb(0, 160, 220)
      .negative
        background-color:rgba(77, 85, 93, 0.2)
        &.active
          color:#fff
          background-color:rgb(77, 85, 93)

    .only-content
      padding:12px 0
      .icon-check_circle
        margin-right:4px
        font-size:24px
        line-height:24px
        color:rgb(147, 153, 159)
        vertical-align:top
        &.active
          color:#00c850
      .text
        font-size:12px
        line-height:24px
        color:rgb(147, 153, 159)
        vertical-align:top
</style>



// WEBPACK FOOTER //
// ratingselect.vue?b54c5ac4